/**
 * Post message service
 */
import { Injectable } from '@angular/core';
import { get, set } from 'lodash';

import { IIframeMessageType } from '@shared/types';
import {
  UiActions,
  APIActions,
  SessionActions,
  XprtDataActions,
} from '@store/actions';
import { ACCESS_TOKEN } from '@config/index';

import { StateService } from '../state-service';
import { TokenSessionService } from '../session/token-session.service';
import { toDate } from '@shared/utils';

@Injectable()
export class PostMessageService {
  public platform: string = 'XVI';
  public portalPlatform: string = 'XPRT';

  // eslint-disable-next-line max-params
  public constructor(
    public apiActions: APIActions,
    public uiActions: UiActions,
    public stateService: StateService,
    public tokenSessionService: TokenSessionService,
    private sessionActions: SessionActions,
    private xprtDataActions: XprtDataActions,
  ) {}

  public sendMessage(
    msgType: string,
    messageId: string = '',
    payload: object = {},
  ): void {
    const message: IIframeMessageType = {
      messageId,
      payload: {
        options: {
          isSubmitEnabled: true,
          ...payload,
        },
        ...payload,
      },
      msg_type: msgType,
      platform: this.platform,
      timestamp: toDate().toISOString(),
    };

    // Fix wrong option name and property reading in portal site selector
    if (get(payload, 'multiselect') === true) {
      set(message, 'payload.multiply', true);
      set(message, 'payload.options.multiply', true);
    }

    this.sendRawMessage(JSON.stringify(message));
  }

  public sendRawMessage(message: string): void {
    parent.postMessage(message, '*');
  }

  public processPostMessage(msg: IIframeMessageType): void {
    if (msg.platform === this.portalPlatform) {
      switch (msg.msg_type) {
        case XprtDataActions.EVENT_SELECTION_SUCCESS:
          this.xprtDataActions.eventSelectionSuccess(msg);
          break;
        case XprtDataActions.EVENT_SELECTION_CANCEL:
          this.xprtDataActions.eventSelectionCancel(msg);
          break;
        case XprtDataActions.EVENT_SELECTION_ERROR:
          this.xprtDataActions.eventSelectionError(msg);
          break;
        case XprtDataActions.GET_ACCESS_TOKEN_SUCCESS:
          const token = msg.payload;
          if (token) {
            const accessToken =
              this.tokenSessionService.createTokenInIframeMode(token);
            this.tokenSessionService.saveToken(accessToken, ACCESS_TOKEN);
            this.sessionActions.restoreAccessToken();
          }
          break;
        default:
          break;
      }
    }
  }
}
